// extracted by mini-css-extract-plugin
export default {"divider":"tTLbXd","compact":"hkYI4d"};